import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const ContentPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-primary text-primary-foreground py-8">
        <div className="container mx-auto px-6">
          <Link to="/" className="inline-flex items-center space-x-2 text-accent hover:text-accent/80 transition-colors mb-4">
            <ArrowLeft className="w-5 h-5" />
            <span>Back to Home</span>
          </Link>
          <h1 className="text-4xl font-bold">Website Content Policy & Guidelines</h1>
          <p className="text-primary-foreground/80 mt-2">Vincent Growth Partners</p>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-6 py-12">
        <div className="max-w-4xl mx-auto space-y-12">
          
          {/* Content Quality & Standards */}
          <section className="bg-card rounded-lg p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-foreground mb-6 text-primary">1. Content Quality & Standards</h2>
            <div className="space-y-4 text-muted-foreground">
              <p>All content will be 100% original, plagiarism-free, and tailored exclusively for your business.</p>
              <p>Tone and style will be professional, engaging, and audience-focused, adapted to suit your brand voice.</p>
              <p>Every piece will undergo thorough checks for grammar, spelling, clarity, and readability prior to submission.</p>
            </div>
          </section>

          {/* SEO Optimization */}
          <section className="bg-card rounded-lg p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-foreground mb-6 text-primary">2. SEO Optimization</h2>
            <div className="space-y-4 text-muted-foreground">
              <p>Content will be strategically optimized for keywords provided by the client or identified through research.</p>
              <p>We follow ethical, white-hat SEO practices only – no keyword stuffing, link spamming, or black-hat tactics.</p>
              <div>
                <p className="mb-2">Content will be structured with:</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Clear headings (H1, H2, H3).</li>
                  <li>Concise paragraphs for easy readability.</li>
                  <li>Relevant internal and external links where valuable.</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Formatting & Submission */}
          <section className="bg-card rounded-lg p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-foreground mb-6 text-primary">3. Formatting & Submission</h2>
            <div className="space-y-4 text-muted-foreground">
              <p>Standard word count: 800–1,200 words per article, unless otherwise specified.</p>
              <p>Deliverables will be provided in Google Docs or Word format for ease of review.</p>
              <p>Deadlines are confirmed upfront, with all content delivered punctually.</p>
            </div>
          </section>

          {/* Revisions & Edits */}
          <section className="bg-card rounded-lg p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-foreground mb-6 text-primary">4. Revisions & Edits</h2>
            <div className="space-y-4 text-muted-foreground">
              <p>Each article includes one complimentary round of revisions (minor edits or adjustments).</p>
              <p>Major changes outside the original brief may incur additional fees.</p>
            </div>
          </section>

          {/* Compliance */}
          <section className="bg-card rounded-lg p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-foreground mb-6 text-primary">5. Compliance</h2>
            <div className="space-y-4 text-muted-foreground">
              <div>
                <p className="mb-2">We will not produce or promote content that violates Google's guidelines or industry best practices, including:</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Harmful, misleading, or discriminatory material.</li>
                  <li>Duplicate, spun, or AI-generated filler content.</li>
                  <li>Non-compliant backlink schemes or manipulative practices.</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Payment Terms */}
          <section className="bg-card rounded-lg p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-foreground mb-6 text-primary">6. Payment Terms</h2>
            <div className="space-y-4 text-muted-foreground">
              <p>Pricing is agreed in advance before project commencement.</p>
              <p>Payment is due upon delivery of the completed content, unless alternative arrangements are agreed.</p>
            </div>
          </section>

          {/* Closing Statement */}
          <section className="bg-primary/5 rounded-lg p-8 shadow-sm border border-primary/20">
            <div className="text-center text-muted-foreground space-y-4">
              <p className="text-lg font-semibold text-primary mb-2">✅ By working with Vincent Growth Partners, you can be confident your content will be strategic, compliant, and growth-driven — built to strengthen your brand authority and generate results.</p>
              <div className="flex justify-center space-x-6 mt-6">
                <a href="/privacy-policy" className="text-primary hover:text-primary/80 underline font-medium">
                  Privacy Policy
                </a>
                <a href="/terms-of-service" className="text-primary hover:text-primary/80 underline font-medium">
                  Terms of Service
                </a>
              </div>
            </div>
          </section>

        </div>
      </main>
    </div>
  );
};

export default ContentPolicy;